/* eslint-disable import/prefer-default-export, max-len */

export const TAG_INSTRUCTIONS_LINK = 'https://support.inmobi.com/choice/how-to-guide/integrate-the-tag-or-sdk/site-implementation-tag/basic-implementation';

export const TAG_AMP_INSTRUCTIONS_LINK = 'https://help.quantcast.com/hc/en-us/articles/13422445376283-Quantcast-Choice-AMP-Implementation-Guide';
